import ProgressCircle from "./ProgressCircle";
import { ContainerSVG } from "./ContainerSVG";


export const ContainerProgressCircle = (
    {
        type = "gl",
        percent = 0
    }
) => {
    return (
        <div className="waste-progress-circle">
            <ProgressCircle percent={percent} />
            <span className="waste-progress-text">
                <ContainerSVG type={type} />
            </span>
        </div>
    )
}